var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{attrs:{"initialValue":_vm.initialValue,"init":_vm.editorOptions,"disabled":_vm.disabled,"outputFormat":_vm.outputFormat,"value":_vm.value},on:{"input":(value) => _vm.$emit('input', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }